import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const RightArrow = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb495__a">
              <rect
                rx="0"
                height="48"
                width="48"
                y="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb495__a)"
            transform="matrix(1 0 0 -1 0 96)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="m21.144 116.77 7.883-7.883a2.03 2.03 0 0 1 2.877.02c.781.78.758 2.002-.023 2.783l-11.335 11.335a1.974 1.974 0 0 1-2.807 0L6.404 111.69c-.782-.781-.805-2.003-.024-2.784a2.031 2.031 0 0 1 2.878-.019l7.886 7.887v-28.59c0-1.104.91-2.04 2.015-2.04 1.075 0 1.985.936 1.985 2.04v28.586Z"
              transform="rotate(-90 5 86.144)"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
